import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem} from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';

const GdnLecturePartRegi = ({record, studentList, open, onClose, reload, origin}) =>  {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [file, set_file] = React.useState(null)
  // const [studentList, set_studentList] = React.useState([])
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [student, set_student] = React.useState(null)
  // redux
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      onClose()
    }
  }

  const onLoad =  async() => {
    // const url = `/student/gdn/phone/${account.user.phone}`
    // const resp = await WebService.get(url)
    // if(resp.repCode === 'ack') {
    //   const repMessage = JSON.parse(resp.repMessage)
    //   const records = JSON.parse(repMessage.records)
    //   set_studentList(records)
    // }
    // else {
    //   openSnackbar(resp.repMessage)
    // }
  }

  const onRegiRequest = async () => {
    const now = moment().format(dateFormat);
    const regi = {
      id:-1,
      lectureId: record.id,
      studentId: student.id,
      statCode: 'S001',
      regiCode:'S001',
      uptTime: now,
      regTime: now
    }

    const url = `/regi/lecture`
    const resp = await WebService.post(url, regi)
    if(resp.repCode === 'ack') {
      openSnackbar('신청되었습니다.')
      set_student(null)
      reload()
      onClose()
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const onRegiCancel = async () => {
    const url = `/regi/cancel/${schola.id}/${record.id}/${student.id}`
    const resp = await WebService.post(url)
    if(resp.repCode === 'ack') {
      openSnackbar('정상적으로 수강취소 되었습니다.')
      set_student(null)
      reload()
      onClose()
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  // React.useEffect(() => {
  //   if(open) {
  //     onLoad()
  //   }
  // },[open])

    
  React.useEffect(() => {
    if(studentList.length === 1) {
      set_student(studentList[0])
    }
  }, [studentList])

  return (
		<Fragment>
			<Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
				<DialogTitle>
					<Typography variant='h5' align='center'>
						{record.title}
					</Typography>
					<Divider></Divider>
				</DialogTitle>
				<DialogContent>
          <br/>
					<FormControl fullWidth>
						<InputLabel id='student' size='small' shrink={student}>
							학생 선택
						</InputLabel>
						<Select
							labelId='student'
							required
							label='student'
							size='small'
              value={student}
							onChange={async (e) => {
                set_student(e.target.value)
							}}>
							{studentList.map((row, index) => {
								return (
									<MenuItem key={index} value={row}>
										{row.name}
									</MenuItem>
								)
							})}

						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button variant='outlined' onClick={handleClose}>
						닫기
					</Button>
          { origin === 'req' ?
            <Button variant='contained' onClick={() => {onRegiRequest()}} disabled={student === null}>
              수강신청
            </Button>
            :
            <Button variant='contained' color='warning' onClick={() => {onRegiCancel()}} disabled={student === null}>
              수강취소
            </Button>

          }
					
          
				</DialogActions>
			</Dialog>
			{renderIndicator()}
		</Fragment>
	)
}

export default GdnLecturePartRegi
